import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';

const isUat = location => {
  return location.host.indexOf('spare-uat') !== -1;
};

const getPixelId = () => {
  const location = window.location;
  if (location.host.indexOf('localhost') !== -1) {
    // no FB Pixel id for localhost
    return null;
  }

  if (process.env.REACT_APP_FBP_ID) {
    return process.env.REACT_APP_FBP_ID;
  }

  return isUat(location) ? '4540716325970867' : '2635486953448425';
};

const getGoogleAnalyticsId = () => {
  const location = window.location;
  if (location.host.indexOf('localhost') !== -1) {
    // no FB Pixel id for localhost
    return null;
  }

  if (process.env.REACT_APP_GA_ID) {
    return process.env.REACT_APP_GA_ID;
  }

  return isUat(location) ? 'UA-129284593-4' : 'UA-129284593-5';
};

/**
 * Initializes tracking.
 */
export const initializeTracking = () => {
  const gaId = getGoogleAnalyticsId();
  if (gaId != null) {
    ReactGA.initialize(gaId);
  }

  const pixelId = getPixelId();
  if (pixelId != null) {
    ReactPixel.init(pixelId, null, {
      autoConfig: true,
      debug: false,
    });
  }
};

/**
 * Tracks visit to the page.
 * @param {string} pagePath Path of the tracked page.
 */
export const trackPageVisit = pagePath => {
  ReactGA.pageview(pagePath);
  ReactPixel.pageView();
};

/**
 * Tracks Google events specified with category and action.
 * @param {string} category Event's category
 * @param {string} action Event's action
 */
export const trackGoogleEvent = (category, action) => {
  ReactGA.event({
    category: category,
    action: action,
  });
};

/**
 * Tracks Facebook events specified with category and action.
 * @param {string} category Event's category
 * @param {string} action Event's action
 */
export const trackFacebookEvent = (category, action) => {
  var evData = {};
  evData['action'] = action;
  ReactPixel.trackCustom(category, evData);
};

/**
 * Tracks Google and Facebook events specified with category and action.
 * @param {string} category Event's category
 * @param {string} action Event's action
 */
export const trackEvent = (category, action) => {
  trackGoogleEvent(category, action);
  trackFacebookEvent(category, action);
};
